export default "__VITE_ASSET__CgGoHrv9__"